<form class="filter-form" [formGroup]="filter_memberForm">
    <h3 class="text-center">Filter</h3>
    <div class="form-group">
        <select class="form-control" formControlName="blood_group">
            <option hidden value="" disabled selected>બ્લડ ગ્રુપ </option>
            <option value="O-">O-</option>
            <option value="O+">O+</option>
            <option value="A+">A+</option>
            <option value="A-">A-</option>
            <option value="B+">B+</option>
            <option value="B-">B-</option>
            <option value="AB+">AB+</option>
            <option value="AB-">AB-</option>
            <option value="No idea">No idea</option>
        </select>
    </div>

    <div class="form-group">
        <div style="position: relative;">
            <select class="form-control" formControlName="education">
                <option hidden value="" disabled selected>શિક્ષણ</option>
                <option value="Standard 1">Standard 1</option>
                <option value="Standard 2">Standard 2</option>
                <option value="Standard 3">Standard 3</option>
                <option value="Standard 4">Standard 4</option>
                <option value="Standard 5">Standard 5</option>
                <option value="Standard 6">Standard 6</option>
                <option value="Standard 7">Standard 7</option>
                <option value="Standard 8">Standard 8</option>
                <option value="Standard 9">Standard 9</option>
                <option value="Standard 10">Standard 10</option>
                <option value="Standard 11 Commerce">Standard 11 Commerce</option>
                <option value="Standard 11 Science">Standard 11 Science</option>
                <option value="Standard 12 Commerce">Standard 12 Commerce</option>
                <option value="Standard 12 Science">Standard 12 Science</option>
                <option value="Diploma">Diploma</option>
                <option value="Bachelors Degree">Bachelors Degree</option>
                <option value="Masters Degree">Masters Degree</option>
                <option value="PHD">PHD</option>
                <option value="Other">Other</option>
            </select>
        </div>
    </div>

    <div class="form-group">
        <div style="position: relative;">
            <select class="form-control" formControlName="user_type_id">
                <option hidden value="" disabled selected>કમિટી</option>
                <option value="2">કારોબારી કમિટી</option>
                <option value="3">યુવા કમિટી</option>
                <option value="4">સ્ટુડન્ટ કમિટી</option>
            </select>
        </div>
    </div>

    <!-- <div class="form-group">
        <div style="position: relative;">
            <select class="form-control" formControlName="maternal_village_name">
                <option hidden value="" disabled selected>માતૃ ગામો</option>
                <option *ngFor="let name of villageListAll" [value]="name.village_name">
                    {{name.village_name}}</option>
            </select>
        </div>
    </div> -->

    <div class="form-group">
        <div style="position: relative;">
            <select class="form-control" formControlName="city_name">
                <option hidden value="" disabled selected>વર્તમાન શહેર</option>
                <option *ngFor="let data of cityListAll" [value]="data.city_name">{{data.city_name}}
                </option>
            </select>
        </div>
    </div>
    <div class="form-group">
        <div style="position: relative;">
            <select class="form-control" formControlName="subdivision_name">
                <option hidden value="" disabled selected>તાલુકો</option>
                <option *ngFor="let name of SubdivisionAll" [value]="name.subdivision_name">
                    {{name.subdivision_name}}</option>
            </select>
        </div>
    </div>

    <div class="form-group">
        <div style="position: relative;">
            <select class="form-control" formControlName="village_name">
                <option hidden value="" disabled selected>ગામ</option>
                <option *ngFor="let name of villageListAll" [value]="name.village_name">
                    {{name.village_name}}</option>
            </select>
        </div>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <button type="reset" (click)="Cancel()" class="btn-common w-100 closeBtn">રદ કરો</button>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <button type="submit" class="btn-common w-100" (click)="submit()">મોકલવું</button>
            </div>

        </div>
    </div>
</form>